<template>
    <div id="false">
        <div class="warning-message">
            Site is in use and the setup screen has been completed before.
        </div>
        <button class="redirect-button" @click="redirectToSupsis">
            Go to supsis.com
        </button>
    </div>
</template>

<script>
export default {
    name: "FalsePage",
    methods: {
        redirectToSupsis() {
            window.location.href = "https://www.supsis.com";
        }
    }
}
</script>

<style scoped>
#false {
    background-image: url("../../../assets/BackgroundOne.png");
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
}

.warning-message {
    background-color: rgba(255, 255, 255, 0.8);
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    font-size: 18px;
    color: #272657;
    margin-bottom: 20px;
}

.redirect-button {
    background-color: #272657;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
}

.redirect-button:hover {
    background-color: #1f1b4d;
}
</style>